/* eslint-disable react-hooks/exhaustive-deps */
import { IconUser, IconX } from "@tabler/icons-react";
import SelectInput from "../../../components/Select";
import { UseFormClearErrors } from "react-hook-form";
import NewinputField from "../../../components/NewInput";
import { useLanguage } from "../../../context/LanguageContext";

const storageTypes = [
  { id: 2, value: "PALLETS", text: "PALLETS" },
  { id: 4, value: "BINS", text: "BINS" },
];

interface AssignDriversModalProps {
  open: boolean;
  onClose: () => void;
  setValue?: any;
  watch?: any;
  register?: any;
  errors?: any;
  clearErrors?: UseFormClearErrors<any>;
  products?: any;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
  categories: any;
  subCategories: any;
  isPending: boolean;
  inline?: boolean;
}

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => {
  const { t } = useLanguage();
  return (
    <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
      <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
        <Icon size={16} className="text-[#212121]" stroke={1.5} />
      </div>
      <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
        {t(title)}
      </p>
    </div>
  );
};

export default function AddProductFetchModal({
  open,
  onClose,
  watch,
  setValue,
  register,
  errors,
  clearErrors,
  products,
  handleSubmit,
  categories,
  subCategories,
  isPending,
  inline,
}: AssignDriversModalProps) {
  const { t } = useLanguage();

  if (!open) return null;

  const formContent = (
    <form onSubmit={(e) => e.preventDefault()} className="p-4">
      {/* Content */}
        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconUser} title="Personal Information" />
          <SelectInput
            className="flex justify-between items-center"
            labelClass="w-full"
            label={t("Category")}
            name="category"
            placeholder={t("Category")}
            value={watch("category")}
            register={register}
            error={errors?.category}
            clearErrors={clearErrors}
            validation={{ required: t("Please select Category") }}
            onChange={(val) => setValue("category", val)}
            selectOptions={
              categories?.map((items: any) => ({
                id: items?.id,
                value: items?.category,
                text: items?.category,
              })) || []
            }
          />

          <SelectInput
            className="flex justify-between items-center"
            labelClass="w-full"
            label={t("Sub Category")}
            name="subCategory"
            placeholder={t("Sub Category")}
            value={watch("subCategory")}
            register={register}
            error={errors?.subCategory}
            clearErrors={clearErrors}
            validation={{ required: t("Please select Sub Category") }}
            onChange={(val) => setValue("subCategory", val)}
            selectOptions={
              subCategories?.map((items: any) => ({
                id: items?.id,
                value: items?.subCategory,
                text: items?.subCategory,
              })) || []
            }
          />
          <SelectInput
            className="flex justify-between items-center"
            labelClass="w-full"
            label={t("Storage Type")}
            name="storageType"
            placeholder={t("Storage Type")}
            value={watch("storageType")}
            register={register}
            error={errors?.storageType}
            clearErrors={clearErrors}
            validation={{ required: t("Select Storage Type") }}
            onChange={(val) => setValue("storageType", val)}
            selectOptions={storageTypes}
          />
          <NewinputField
            className="flex justify-between items-center"
            labelClass="w-full"
            name="capacity"
            type="number"
            title={t("Capacity")}
            register={register}
            error={errors?.capacity}
            validation={{ required: t("Capacity is required") }}
            placeholder={t("Capacity")}
          />
        </div> 
        {/* Personal Information Section */}
        {/* <div className="flex justify-end p-5 border-t border-gray-100 bg-gray-50/50">
          <button
            onClick={handleSubmit}
            disabled={isPending}
            className="px-6 py-2 rounded-full bg-[#FBD037] text-[#131327] font-semibold hover:bg-yellow-400 hover:shadow-md active:scale-95 transition-all duration-150 flex items-center justify-center min-w-[80px]"
          >
            {isPending ? (
              <div className="w-5 h-5 border-2 border-slate-700 border-t-transparent rounded-full animate-spin"></div>
            ) : (
              "Add"
            )}
          </button>
        </div> */} 
    </form>
  );

  if (inline) {
    return formContent;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 animate-fade-in">
      <div className="w-[650px] max-w-full px-4">{formContent}</div>
    </div>
  );
}
